import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "box",
  "use": "box-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"box\"><path d=\"M1.48 1029.842h21.04v19.04H1.48Z\" style=\"fill:#e5e5e5;stroke:currentColor;stroke-width:.95975173;stroke-dasharray:1.91950336,.95975168\" transform=\"translate(.05 -1027.676)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbolimport SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "box",
  "use": "box-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"box\"><path d=\"M1.48 1029.842h21.04v19.04H1.48Z\" style=\"fill:#e5e5e5;stroke:currentColor;stroke-width:.95975173;stroke-dasharray:1.91950336,.95975168\" transform=\"translate(.05 -1027.676)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol